module.exports = __webpack_public_path__ + "static/img/Tayte.Pears.56050c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tayte.Pears.jpg
// module id = NVmY
// module chunks = 0